var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('widget',{attrs:{"title":"widgets.upcomingCompetitions.title","icon":"mdi-medal-outline","route":"/competitions"}},[_c('competitions-list',{attrs:{"paddingless":"","competitions":_vm.getUpcomingCompetitions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }